import React, { useContext, useState } from 'react'

import { Button, message, Space } from 'antd';

import './Layout.css'
import Navbar from './Navbar';
import SideBar from './SideBar';
import { PromiseSesionContext } from '../Machines/ErrorMachine';
import NavbarAdmin from './NavbarAdmin';


interface Props {
    children: React.ReactNode
}

const Layout = ({children}:Props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [open, setOpen] = useState<boolean>(false);
  const {sesion, sendSesion } = useContext(PromiseSesionContext);

  

  return (
    <div className={sesion.context.rol==2 ? "Layout-component-admin" :'Layout-component'}>
        {contextHolder}
        {sesion.context.rol==2 ? <NavbarAdmin /> :<Navbar setOpen={setOpen} />}

        <SideBar open={open} setOpen={setOpen} ></SideBar>
        <div className={sesion.context.rol==2 ? "Layout-children-admin":'Layout-children'}>
            {children}
        </div>
        
    </div>
  )
}

export default Layout